import React from "react";
import styled from "styled-components";
import FigureCover from "../FigureCover";

const Cell = styled.div`
  width: 25px;
  height: 25px;
  // background: blue;
`;

const gridStyle = {
  display: "grid",
  gridGap: "5px",
  gridTemplateColumns: "66% 1fr",
  gridAutoRows: "0"
};
const group1Style = {
  display: "grid",
  gridGap: "5px",
  gridTemplateRows: "65% 1fr",
  gridAutoRows: "0"
};
const group2Style = {
  display: "grid",
  // gridGap: "5px",
  gridTemplateRows: "55% 1fr"
};
const group2InnerStyle = {
  display: "grid",
  gridGap: "5px",
  gridTemplateRows: "66% 33%"
};

const Deco = ({ dominant, vibrant, muted }) => (
  <div className='deco overflow-hidden'>
    <ul className='flex flex-col items-end'>
      {dominant.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
      <li>
        <Cell></Cell>
      </li>
      <li>
        <Cell></Cell>
      </li>
      <li>
        <Cell></Cell>
      </li>
      {vibrant.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
      <li>
        <Cell></Cell>
      </li>
      {muted.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
      {dominant.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
      <li>
        <Cell></Cell>
      </li>
      <li>
        <Cell></Cell>
      </li>
      <li>
        <Cell></Cell>
      </li>
      {vibrant.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
      <li>
        <Cell></Cell>
      </li>
      {muted.map((el, i) => (
        <li key={i}>
          <Cell
            className='cell'
            style={{
              backgroundColor: el
            }}></Cell>
        </li>
      ))}
    </ul>
  </div>
);

const PC6 = ({ input }) => {
  // console.log(input[0].asset.metadata.palette);
  const dominant = input.map(
    el => el.asset.metadata.palette.dominant.background
  );
  const vibrant = input.map(el => el.asset.metadata.palette.vibrant.background);
  const muted = input.map(el => el.asset.metadata.palette.muted.background);

  return (
    <div className='template6 '>
      <div className='grid h-screen' style={gridStyle}>
        <div className='group h-screen' style={group1Style}>
          <div>
            <FigureCover input={input[0]} />
          </div>
          <div>
            <FigureCover input={input[1]} />
          </div>
        </div>

        <div className='group h-screen' style={group2Style}>
          <div style={group2InnerStyle}>
            <div>
              <FigureCover input={input[2]} />
            </div>
            <div>
              {/* <Pre input={input[3]} /> */}
              <FigureCover input={input[3]} />
            </div>
          </div>
          <Deco dominant={dominant} vibrant={vibrant} muted={muted} />
        </div>
      </div>
    </div>
  );
};

export default PC6;
